<form [formGroup]="equipmentForm">
    <app-picklist
        [formControl]="equipmentForm.controls['selectedEquipment']"
        [showValidations]="showValidations"
        [source]="availableEquipment"
        [target]="selectedEquipment"
        sourceHeader="{{'admin.tools.create-modal.pick-list.equipment.leftHeader' | translate}}"
        targetHeader="{{'admin.tools.create-modal.pick-list.equipment.rightHeader' | translate}}">
    </app-picklist>
</form>
